import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.LOGOUT_PAGE]: {
    [ROLE.CONTAINER]: [ELEMENT.LOGOUT],
  },
} as TValidTestId;
